import { render } from "./EmployeeData.vue?vue&type=template&id=1be82df3&scoped=true"
import script from "./EmployeeData.vue?vue&type=script&lang=js"
export * from "./EmployeeData.vue?vue&type=script&lang=js"

import "./employee-data.scss?vue&type=style&index=0&id=1be82df3&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be82df3"]])

export default __exports__